(function () {
  'use strict';

  var SHARE_SVG = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8M16 6l-4-4-4 4M12 2v13"/></svg>';

  var popup = null;
  var highlightTooltip = null;
  var currentShareData = null; // { text, url, type }

  /* ── Popup ── */

  function createPopup() {
    var el = document.createElement('div');
    el.id = 'pl-share-popup';
    el.className = 'pl-share-popup';
    el.setAttribute('hidden', '');
    el.innerHTML =
      '<button class="pl-share-popup__item" data-platform="twitter">X</button>' +
      '<button class="pl-share-popup__item" data-platform="facebook">Facebook</button>' +
      '<button class="pl-share-popup__item" data-platform="copy">Copy link</button>' +
      '<button class="pl-share-popup__item" data-platform="email">Email</button>';
    document.body.appendChild(el);
    el.addEventListener('click', onPopupItemClick);
    return el;
  }

  function positionPopup(x, y) {
    var popupWidth = 160;
    var left = x;
    if (left + popupWidth > window.innerWidth - 8) left = window.innerWidth - popupWidth - 8;
    if (left < 8) left = 8;
    popup.style.position = 'fixed';
    popup.style.left = left + 'px';
    popup.style.top = (y + 6) + 'px';
    var popupHeight = popup.offsetHeight || 160;
    if (y + 6 + popupHeight > window.innerHeight) {
      popup.style.top = (y - 6 - popupHeight) + 'px';
    }
  }

  function showPopup(anchorEl) {
    if (!popup) popup = createPopup();
    popup.removeAttribute('hidden');
    var rect = anchorEl.getBoundingClientRect();
    positionPopup(rect.left, rect.bottom);
  }

  function showPopupAtEvent(e) {
    if (!popup) popup = createPopup();
    popup.removeAttribute('hidden');
    positionPopup(e.clientX - 80, e.clientY);
  }

  function hidePopup() {
    if (popup) popup.setAttribute('hidden', '');
    currentShareData = null;
  }

  function onPopupItemClick(e) {
    var btn = e.target.closest('[data-platform]');
    if (!btn || !currentShareData) return;

    var platform = btn.getAttribute('data-platform');
    var text = currentShareData.text;
    var url = currentShareData.url;
    var type = currentShareData.type;
    var articleTitle = document.title;

    switch (platform) {
      case 'twitter':
        window.open(
          'https://twitter.com/intent/tweet?text=' + encodeURIComponent(text) + '&url=' + encodeURIComponent(url),
          '_blank',
          'noopener,noreferrer'
        );
        break;
      case 'facebook':
        window.open(
          'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
          '_blank',
          'noopener,noreferrer'
        );
        break;
      case 'copy':
        var copyText = '\u201c' + text + '\u201d \u2014 ' + articleTitle + ' | ' + url;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(copyText).catch(function () {
            fallbackCopy(copyText);
          });
        } else {
          fallbackCopy(copyText);
        }
        break;
      case 'email':
        window.location.href =
          'mailto:?subject=' + encodeURIComponent(articleTitle) +
          '&body=' + encodeURIComponent(text) + '%0A%0A' + encodeURIComponent(url);
        break;
    }

    trackShare(platform, type);
    hidePopup();
    hideHighlightTooltip();
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  /* ── Analytics ── */

  function trackShare(platform, type) {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'article_share',
        share_method: platform,
        share_type: type,
        article_url: window.location.href
      });
    }
  }

  /* ── Blockquote buttons ── */

  function assignBlockquoteIds() {
    var figs = document.querySelectorAll('figure.article-blockquote');
    // Converter (code.gs buildBlockquoteHtml) now bakes id="quote-N" into
    // the HTML at conversion time. Honor any IDs already present and
    // fill gaps with the next free integer so a manual quote added in
    // the Shopify editor can't collide with a converter-set ID.
    var used = Object.create(null);
    figs.forEach(function (fig) {
      var m = fig.id && fig.id.match(/^quote-(\d+)$/);
      if (m) used[parseInt(m[1], 10)] = true;
    });
    var next = 1;
    figs.forEach(function (fig) {
      if (fig.id) return;
      while (used[next]) next++;
      fig.id = 'quote-' + next;
      used[next] = true;
      next++;
    });
  }

  function getQuoteText(fig) {
    var bq = fig.querySelector('blockquote');
    var text = bq ? bq.innerText.trim() : fig.innerText.trim();

    var figcaption = fig.querySelector('figcaption');
    if (figcaption) {
      var creator = figcaption.innerText.trim();
      if (creator) text = text + ' \u2014 ' + creator;
    }

    return text;
  }

  function injectQuoteButtons() {
    document.querySelectorAll('figure.article-blockquote').forEach(function (fig) {
      // Avoid double-injecting
      if (fig.querySelector('.pl-share-btn--quote')) return;

      var btn = document.createElement('button');
      btn.className = 'pl-share-btn pl-share-btn--quote';
      btn.setAttribute('aria-label', 'Share this quote');
      btn.setAttribute('data-quote-id', fig.id);
      btn.innerHTML = SHARE_SVG + ' <span>Share</span>';

      fig.appendChild(btn);

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var quoteId = btn.getAttribute('data-quote-id');
        var targetFig = document.getElementById(quoteId);
        if (!targetFig) return;

        var text = getQuoteText(targetFig);
        var url = window.location.origin + window.location.pathname + '#' + quoteId;

        currentShareData = { text: text, url: url, type: 'blockquote' };
        showPopup(btn);
      });
    });
  }

  /* ── Highlight tooltip ── */

  function createHighlightTooltip() {
    var el = document.createElement('button');
    el.className = 'pl-share-highlight-tooltip';
    el.setAttribute('hidden', '');
    el.setAttribute('aria-label', 'Share selected text');
    el.innerHTML = SHARE_SVG + ' Share';
    document.body.appendChild(el);

    el.addEventListener('click', function (e) {
      e.stopPropagation();
      if (!currentShareData) return;
      var savedData = { text: currentShareData.text, url: currentShareData.url, type: currentShareData.type };
      var clientX = e.clientX;
      var clientY = e.clientY;
      hideHighlightTooltip();
      // Delay showing popup so the mousedown outside-click handler doesn't immediately dismiss it
      setTimeout(function () {
        currentShareData = savedData;
        if (!popup) popup = createPopup();
        popup.removeAttribute('hidden');
        positionPopup(clientX - 80, clientY);
      }, 10);
    });

    return el;
  }

  function hideHighlightTooltip() {
    if (highlightTooltip) highlightTooltip.setAttribute('hidden', '');
  }

  function onSelectionChange() {
    var sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) {
      hideHighlightTooltip();
      return;
    }

    var text = sel.toString().trim();
    if (text.length < 20) {
      hideHighlightTooltip();
      return;
    }

    // Only show within content area
    var range = sel.getRangeAt(0);
    var contentEl = document.querySelector('.pl-article-body__content');
    if (!contentEl || !contentEl.contains(range.commonAncestorContainer)) {
      hideHighlightTooltip();
      return;
    }

    var rect = range.getBoundingClientRect();
    if (!highlightTooltip) highlightTooltip = createHighlightTooltip();

    currentShareData = { text: text, url: window.location.href, type: 'highlight' };

    highlightTooltip.removeAttribute('hidden');

    var tooltipWidth = 90;
    var left = rect.left + (rect.width / 2) - (tooltipWidth / 2);
    if (left < 8) left = 8;
    if (left + tooltipWidth > window.innerWidth - 8) left = window.innerWidth - tooltipWidth - 8;

    var top = rect.top - 40;
    if (top < 8) top = rect.bottom + 8;

    highlightTooltip.style.top = top + 'px';
    highlightTooltip.style.left = left + 'px';
  }

  function initHighlightToShare() {
    var contentEl = document.querySelector('.pl-article-body__content');
    if (!contentEl) return;

    contentEl.addEventListener('mouseup', function () {
      setTimeout(onSelectionChange, 10);
    });

    contentEl.addEventListener('touchend', function () {
      setTimeout(onSelectionChange, 50);
    });
  }

  /* ── Outside click / Escape ── */

  document.addEventListener('mousedown', function (e) {
    if (popup && !popup.hasAttribute('hidden') && !popup.contains(e.target)) {
      hidePopup();
    }
    if (highlightTooltip && !highlightTooltip.hasAttribute('hidden') && !highlightTooltip.contains(e.target)) {
      hideHighlightTooltip();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      hidePopup();
      hideHighlightTooltip();
    }
  });

  document.addEventListener('selectionchange', function () {
    var sel = window.getSelection();
    if (!sel || sel.toString().trim().length < 20) {
      hideHighlightTooltip();
    }
  });

  /* ── Hash landing ── */
  // When someone opens a shared quote link (…/article#quote-N), the
  // browser's native hash scroll runs during HTML parsing — before this
  // script has assigned IDs to the figures — so it silently fails and
  // the page lands at the top. We retry the scroll the moment IDs are
  // assigned (right after assignBlockquoteIds in init), without waiting
  // for DOMContentLoaded. Yesterday's converter dim-attr fix means lazy
  // images above the quote already reserve their slot, and any residual
  // drift (including the inline image-figure rewrite that runs on DCL)
  // is absorbed by plCompensateClsToTarget — same path as ToC clicks.
  function scrollToHashIfQuote() {
    var hash = location.hash;
    if (!hash || !/^#quote-\d+$/.test(hash)) return;
    var target = document.getElementById(hash.slice(1));
    if (!target) return;

    // Honors scroll-padding-block-start on <html> (sticky-nav offset).
    target.scrollIntoView({ block: 'start', behavior: 'auto' });

    if (typeof window.plCompensateClsToTarget === 'function') {
      // Next tick so the scrollIntoView lands before we measure.
      setTimeout(function () { window.plCompensateClsToTarget(target); }, 0);
    }
  }

  /* ── Init ── */

  function init() {
    assignBlockquoteIds();
    scrollToHashIfQuote();
    injectQuoteButtons();
    initHighlightToShare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
